import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Flex, IconButton, Text, getPaletteColor } from 'pcln-design-system'
import { ChevronDown, ChevronUp } from 'pcln-icons'

const FixedFlex = styled(Flex)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  transition-duration: 1s;
  z-index: 9000;

  ${(props) =>
    props.position === 'bottom'
      ? `
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `
      : `
      transform: translateY(calc(-100vh + 100%));
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
`

const RoundIconButton = styled(IconButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${getPaletteColor('background.lightest')};
  border-radius: 50%;

  &:hover {
    background-color: ${getPaletteColor('background.lightest')};
  }
`

function PreviewBanner({ onClick, ...props }) {
  const [position, setPosition] = useState('bottom')

  function togglePosition() {
    setPosition((prevPosition) => setPosition(prevPosition === 'bottom' ? 'top' : 'bottom'))
  }

  const Icon =
    position === 'bottom' ? (
      <ChevronUp color='primary' title='chevron-up' />
    ) : (
      <ChevronDown color='primary' title='chevron-down' />
    )

  return (
    <FixedFlex
      borderRadius='2xl'
      color='alert'
      position={position}
      p={3}
      data-testid='preview-banner'
      {...props}
    >
      <Flex justifyContent='space-between' alignItems='center' width='100%' mx={2}>
        <Text color='text.lightest' textStyle='display2'>
          Preview Mode Active
        </Text>
        <Flex>
          <Button borderRadius='2xl' color='background.lightest' size='small' onClick={onClick}>
            <Text color='primary'>Deactivate</Text>
          </Button>
          <RoundIconButton icon={Icon} width='32px' onClick={togglePosition} ml={4} />
        </Flex>
      </Flex>
    </FixedFlex>
  )
}

PreviewBanner.propTypes = {
  onClick: PropTypes.func,
}

export default memo(PreviewBanner)
